import { BaseApi } from '../base-api';

export class CodeInstructionsApi extends BaseApi {
  protected readonly prefix = '';

  sendInstallCodeEmail = () => this.post('code_auto_instructions');
}
